import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const DEFAULT_CONTENT = {
  hero_eyebrow: "Restaurant · Genève · Pâquis",
  hero_title_1: "La table",
  hero_title_2: "suisse-italienne",
  hero_title_3: "du cœur de Genève.",
  hero_paragraph:
    "Charbonnade, fondues, filet de perche et l’incontournable entrecôte Matze. Rue Chaponnière, à deux pas de Cornavin.",
  hero_image:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dfb03dda-ca55-4e8f-88f2-8942803ea312/artifacts/eiuvpia3_WhatsApp%20Image%202026-07-19%20at%2023.22.08.jpeg",
  intro_eyebrow: "La maison",
  intro_title_1: "Une cuisine de marché,",
  intro_title_2: "fidèle à ses",
  intro_title_italic: "racines",
  intro_paragraph:
    "À La Matze, la carte se réinvente au fil des saisons. Le chef puise dans le meilleur des traditions suisse et italienne pour composer un choix simple et généreux — charbonnade, fondues, filet de perche ou l’entrecôte Matze.",
  intro_hours:
    "Rue Chaponnière 7 · lundi au samedi · 10h – 22h.\nGroupes et anniversaires sur demande.",
  specialty_0_name: "Entrecôte Matze",
  specialty_0_image:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dfb03dda-ca55-4e8f-88f2-8942803ea312/artifacts/mh1eyoyc_WhatsApp%20Image%202026-07-20%20at%2000.59.01.jpeg",
  specialty_1_name: "Charbonnade",
  specialty_1_image:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dfb03dda-ca55-4e8f-88f2-8942803ea312/artifacts/ktv209zz_WhatsApp%20Image%202026-07-20%20at%2000.13.56.jpeg",
  specialty_2_name: "Filet de perche",
  specialty_2_image:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_dfb03dda-ca55-4e8f-88f2-8942803ea312/artifacts/14eer4jg_WhatsApp%20Image%202026-07-20%20at%2000.58.48.jpeg",
  specialty_3_name: "Fondues",
  specialty_3_image:
    "https://customer-assets-jt897jd0.emergentagent.net/job_matze-suisse/artifacts/7crgsfat_WhatsApp%20Image%202026-07-20%20at%2000.33.45.jpeg",
  phone_display: "+41 22 732 79 61",
  phone_tel: "+41227327961",
  whatsapp_number: "41764254935",
  whatsapp_display: "+41 76 425 49 35",
  address: "Rue Chaponnière 7, 1201 Genève",
  email: "restolamatze@gmail.com",
  footer_description:
    "Cuisine suisse-italienne, rue Chaponnière depuis toujours. Charbonnade, fondues, filet de perche, entrecôte Matze.",
  menu_pdf_url: "/menu-la-matze.pdf",
  seo_title: "La Matze — Restaurant suisse-italien à Genève · Charbonnade & Fondues",
  seo_description:
    "Restaurant La Matze à Genève (Pâquis, rue Chaponnière 7). Cuisine suisse-italienne : charbonnade, fondues, filet de perche, entrecôte Matze. Réservation par WhatsApp. Ouvert lundi–samedi 10h–22h.",
  seo_keywords:
    "La Matze, restaurant Genève, restaurant Pâquis, charbonnade Genève, fondue Genève, filet de perche Léman, entrecôte Matze, restaurant suisse italien Genève, pizzeria Genève, réservation restaurant WhatsApp",
};

export const CONTENT_FIELDS = Object.keys(DEFAULT_CONTENT);

// Resolve any image URL — /api/uploads/xxx are served by our backend, absolute URLs stay as-is.
// Legacy /uploads/ paths (older DB entries) are auto-rewritten for backward compatibility.
export function resolveImg(u) {
  if (!u) return u;
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  const path = u.startsWith("/uploads/") ? `/api${u}` : u;
  return `${BACKEND_URL}${path.startsWith("/") ? "" : "/"}${path}`;
}

const SiteContext = createContext({
  content: DEFAULT_CONTENT,
  gallery: [],
  refresh: () => {},
  loading: false,
});

export function SiteProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      const { gallery_items, ...fields } = data;
      setContent({ ...DEFAULT_CONTENT, ...fields });
      setGallery(Array.isArray(gallery_items) ? gallery_items : []);
    } catch {
      /* keep defaults */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteContext.Provider value={{ content, gallery, refresh, loading }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}

export function waLink(content) {
  const msg = "Bonjour, je souhaite réserver une table chez La Matze.";
  const num = (content?.whatsapp_number || DEFAULT_CONTENT.whatsapp_number).replace(/\D/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
}
